export const NAMESPACE = 'flatJobs';

export const CLEANUP = `${NAMESPACE}/CLEANUP`;
